import { Environment } from 'src/environments/interfaces';

const wsProtocol = location.protocol === 'https:' ? 'wss:' : 'ws:';
export const environment: Environment = {
	production: true,
	demo: true,
	authenticated: false,
	hmr: false,
	serverEndpoint: `${location.protocol}//${location.host}`,
	wsServerEndpoint: `${wsProtocol}//${location.host}/`,
};
